<template>
  <div class="gx-goods">
    <gx-loading :show="loading" />
    <!-- <h1 class="gx-main__title">{{ title }}</h1> -->

    <!-- 筛选栏 -->
    <div class="gx-goods__filter custom-form-wrap">
      <el-form inline size="mini">
        <el-form-item>
          <el-select v-model="searchData.shop_groupids" multiple clearable collapse-tags placeholder="全部分组" @change="doSearch">
            <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id" />
            <el-option v-if="isHost" label="未分组" :value="-1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchData.shop_id" placeholder="全部店铺" clearable class="" @change="onShopChange">
            <el-option v-for="s in shopList" :key="s.shop_id" :value="s.shop_id" :label="s.shop_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchData.product_title" class="" placeholder="商品名称" clearable @blur="doSearch" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchData.platform_product_id" clearable placeholder="商品ID" @blur="doSearch" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchData.cloud_source_product_id" class="" placeholder="云商品来源ID" @blur="doSearch" />
        </el-form-item>

      </el-form>
      <el-form inline size="mini" class="gx-goods__form">
<!--        <el-form-item label="发货方式">
          <el-select v-model="searchData.delivery" placeholder="全部" clearable @blur="doSearch">
            <el-option :value="1" label="现货"></el-option>
            <el-option :value="2" label="预售"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item>
          <el-date-picker class=""
                          v-model="searchData.created_at"
                          type="datetimerange"
                          align="right"
                          unlink-panels
                          range-separator="-"
                          start-placeholder="铺货开始时间"
                          end-placeholder="铺货结束时间"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']"
                          style="width: 315px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="销量">
          <el-input-number v-model="searchData.sales_min" placeholder="最小值" :min="0" :precision="0" :controls="false" class="gx-goods__filter-input-num"></el-input-number>
          <span style="margin: 0 4px;color: #999;">~</span>
          <el-input-number v-model="searchData.sales_max" placeholder="最大值" :min="0" :precision="0" :controls="false" class="gx-goods__filter-input-num"></el-input-number>
        </el-form-item>
        <el-form-item class="btns">
          <button type="button" class="btn btn--primary" @click="doSearch">查询</button>
          <button type="button" class="btn" @click="resetSearch">重置</button>
          <template v-if="shopType === 1">
            <button type="button" class="btn" :disabled="openLoading" @click="openBixi" >低效商品</button>
            <button type="button" class="btn" :disabled="openLoading" @click="openCleanBixi">清理商品</button>
          </template>
        </el-form-item>
      </el-form>
    </div>

    <!-- 列表面板：状态 tabs + 批量操作 + 表格 + 分页 -->
    <div class="gx-goods__card">
    <!-- 状态 tabs -->
    <div class="gx-goods__status-tabs">
      <button v-for="t in currentStatusTabs" :key="t.key || t.label" class="gx-goods__status-tab" :class="{ 'gx-goods__status-tab--on': isStatusTabActive(t) }"
              :style="isStatusTabActive(t)?`color:${t.color};border-bottom: 2px solid ${t.color}`:''" @click="switchState(t)">
        {{ t.label }}<span class="gx-goods__status-count">{{ getStatusCount(t) }}</span>
      </button>
    </div>

    <!-- 批量操作 -->
    <div class="gx-goods__batch">
      <span class="gx-goods__batch-label">共 {{ pageData.total }} 条</span>
      <template v-if="isDoudian">
        <button v-if="activeDoudianTab === 'selling'" class="gx-goods__btn" @click="showFeatureInProgress">滞销商品下架</button>
        <button v-if="activeDoudianTab === 'off_shelf_reminder'" class="gx-goods__btn" @click="showFeatureInProgress">批量关联</button>
        <button v-if="['all', 'selling', 'warehouse', 'draft', 'review_rejected', 'off_shelf_reminder'].includes(activeDoudianTab)" class="gx-goods__btn" @click="openFilteredEditor">商品编辑</button>
        <button v-if="['selling', 'warehouse', 'draft'].includes(activeDoudianTab)" class="gx-goods__btn" @click="showFeatureInProgress">批量改价</button>
        <button v-if="['selling', 'warehouse', 'draft', 'off_shelf_reminder'].includes(activeDoudianTab)" class="gx-goods__btn" @click="showFeatureInProgress">批量改发货时间</button>
        <button v-if="['warehouse', 'draft'].includes(activeDoudianTab)" class="gx-goods__btn" :disabled="!checkList.length" @click="batchOp(1)">批量上架</button>
        <button v-if="['selling', 'draft', 'off_shelf_reminder'].includes(activeDoudianTab)" class="gx-goods__btn" :disabled="!checkList.length" @click="batchOp(2)">批量下架</button>
        <button v-if="activeDoudianTab === 'pending'" class="gx-goods__btn" @click="showFeatureInProgress">停止铺货</button>
        <button v-if="activeDoudianTab === 'distribute_failed'" class="gx-goods__btn" @click="showFeatureInProgress">一键重铺</button>
        <button v-if="['selling', 'warehouse', 'draft', 'banned', 'review_rejected', 'off_shelf_reminder', 'pending', 'distribute_failed'].includes(activeDoudianTab)" class="gx-goods__btn gx-goods__btn--danger" :disabled="!checkList.length" @click="batchOp(3)">批量删除</button>
        <button v-if="['off_shelf_reminder', 'pending', 'distribute_failed'].includes(activeDoudianTab)" class="gx-goods__btn gx-goods__btn--danger" @click="showFeatureInProgress">全部删除</button>
        <button v-if="['all', 'selling', 'warehouse', 'draft'].includes(activeDoudianTab)" class="gx-goods__btn" :disabled="syncSubmitting" @click="postSyncProduct">{{ syncSubmitting ? '同步中...' : '一键同步' }}</button>
      </template>
      <template v-else>
        <button class="gx-goods__btn" disabled v-if="state===3">滞销商品下架</button>
        <button class="gx-goods__btn" disabled v-if="[3,4,6].includes(state)">批量改价</button>
        <button class="gx-goods__btn" :disabled="!checkList.length" @click="batchOp(1)" v-if="[4,6].includes(state)">批量上架</button>
        <button class="gx-goods__btn" disabled v-if="[3,4,6].includes(state)">批量改发货时间</button>
        <button class="gx-goods__btn" disabled v-if="state===2">一键重铺</button>
        <button class="gx-goods__btn" :disabled="!checkList.length" @click="batchOp(2)" v-if="[2,3,6].includes(state)">批量下架</button>
        <button class="gx-goods__btn" disabled v-if="state===1">停止铺货</button>
        <button class="gx-goods__btn gx-goods__btn--danger" :disabled="!checkList.length" @click="batchOp(3)" v-if="state!=0">批量删除</button>
        <button class="gx-goods__btn gx-goods__btn--danger" disabled v-if="[1,2].includes(state)">全部删除</button>
      </template>
      <button v-if="!isDoudian" class="gx-goods__btn" @click="clearCheck">清空已选</button>
    </div>

    <!-- 表格 -->
    <div class="gx-goods__table">
      <table>
        <thead>
          <tr>
            <th style="width: 36px">
              <span class="gx-goods__checkbox" :class="{ 'gx-goods__checkbox--on': allChecked }" @click="toggleAll">
                <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </span>
            </th>
            <th>店铺名</th>
            <th>货品信息</th>
            <th>卖价</th>
            <th>采购价</th>
            <th class="gx-goods__sortable" @click="bindSort">
              销量
              <span class="gx-goods__sort-arrow" :class="{ 'gx-goods__sort-arrow--on': searchData.sales_sort == 1 }">▲</span>
              <span class="gx-goods__sort-arrow" :class="{ 'gx-goods__sort-arrow--on': searchData.sales_sort == 2 }">▼</span>
            </th>
            <th>商品状态</th>
            <th>铺货时间</th>
            <th style="width: 240px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in list" :key="item.id">
            <td>
              <span class="gx-goods__checkbox" :class="{ 'gx-goods__checkbox--on': checkList.includes(item.id) }" @click="toggleOne(item.id)">
                <svg v-if="checkList.includes(item.id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
              </span>
            </td>
            <td>
              {{ item.shop_name }}
            </td>
            <td>
              <div class="gx-goods__info">
                <el-popover
                    placement="top"
                    :fallback-placements="[ 'top', 'right', 'left','bottom']"
                    width="350"
                    trigger="hover" :disabled="!item.img">
                  <div class="popover-content">
                    <el-image :src="item.img" fit="contain" style="width:100%;height: auto"></el-image>
                  </div>
                  <span class="gx-goods__img" slot="reference"><img v-if="item.img" :src="item.img" loading="lazy" decoding="async" alt="" /><span v-else>🛍️</span></span>
                </el-popover>
                <div class="gx-goods__info-body">
                  <div class="gx-goods__title">{{ item.product_title }}</div>
                  <div class="gx-goods__meta">ID：{{ item.platform_product_id }}
                    <!-- <span v-if="item.shop_name"> · {{ item.shop_name }}</span> -->
                  </div>
                </div>
              </div>
            </td>
            <td class="gx-goods__mono gx-goods__gold">¥{{ item.distribute_price }}</td>
            <td class="gx-goods__mono">¥{{ item.product_price }}</td>
            <td class="gx-goods__mono">{{ item.sales_num ?? '--' }}</td>
            <td>
              <el-tooltip v-if="item.platform_error_msg && (item.distribute_status == 5 || item.platform_status == 2 || item.primary_status === 'distribute_failed')" placement="top">
                <div slot="content" class="gx-goods__status-error">{{ item.platform_error_msg }}</div>
                <span class="gx-goods__status" :style="statusStyle(item)">{{ getProductStatusText(item) }}</span>
              </el-tooltip>
              <span v-else class="gx-goods__status" :style="statusStyle(item)">{{ getProductStatusText(item) }}</span>
              <span v-for="badge in getProductStatusBadges(item)" :key="badge.code" class="gx-goods__status gx-goods__status-badge" :class="{ 'gx-goods__status-badge--danger': badge.code === 'banned' }">{{ badge.text }}</span>
            </td>
            <td class="gx-goods__mono gx-goods__dim">{{ item.created_at }}</td>
            <td>
              <div class="gx-goods__ops">
                <button v-if="canEditProduct(item)" class="gx-goods__op" @click="openEditor(item)">编辑</button>
<!--                <button v-if="Number(item.platform_product_id) > 0 && shopType !== 7" class="gx-goods__op" >关联</button>-->
                <button v-if="canOperateProduct(item)" class="gx-goods__op " :class="getProductOperationType(item) === 2 ? 'gx-goods__op--warning' : 'gx-goods__op--red'" @click="singleOp(item, getProductOperationType(item))">{{ getProductOperationText(item) }}</button>
                <button class="gx-goods__op gx-goods__op--danger" @click="singleOp(item, 3)">删除</button>
              </div>
              <div class="gx-goods__ops">
                <button class="gx-goods__op gx-goods__op--primary" @click="handleViewCloudProduct(item)">查看云商品</button>
                <button class="gx-goods__op" @click="handleViewProductMarks(item)">查看标记货源</button>
                <button class="gx-goods__op gx-goods__op--primary" @click="handleViewReplaceLogs(item)">SKU替换记录</button>
              </div>
            </td>
          </tr>
          <tr v-if="!list.length">
            <td :colspan="8" class="gx-goods__empty">暂无商品数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 分页 -->
    <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
      <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.page_size" :page-sizes="pageSizeOptions" @pagination="getList(true, pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
    </div>
    </div>

    <!-- SKU替换记录弹窗 -->
    <div v-if="replaceLogShow" class="gx-goods__modal" @click.self="replaceLogShow = false">
      <div class="gx-goods__modal-box gx-goods__modal-box--lg">
        <div class="gx-goods__modal-head">
          <span class="gx-goods__modal-title">SKU替换记录</span>
          <button class="gx-goods__modal-close" @click="replaceLogShow = false">✕</button>
        </div>
        <div class="gx-goods__modal-body">
          <div class="gx-goods__tip">点击链接可查看详情</div>
          <div class="gx-goods__table gx-goods__table--plain">
            <table>
              <thead>
                <tr>
                  <th>时间</th>
                  <th>链接</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in replaceLogList" :key="i">
                  <td class="gx-goods__mono">{{ r.created_at_text || r.created_at || '--' }}</td>
                  <td><a :href="r.url" target="_blank" rel="noopener noreferrer" class="gx-goods__link">{{ r.url }}</a></td>
                </tr>
                <tr v-if="!replaceLogList.length">
                  <td :colspan="2" class="gx-goods__empty">暂无替换记录</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <div class="gx-goods__pager" v-if="replaceLogPage.total > 0">
            <span class="gx-goods__pager-total">共 {{ replaceLogPage.total }} 条</span>
            <div class="gx-goods__pager-btns">
              <button class="gx-goods__page" :disabled="replaceLogPage.page <= 1" @click="getReplaceLogPage(replaceLogPage.page - 1)">上一页</button>
              <button v-for="n in replaceLogPages" :key="n" class="gx-goods__page" :class="{ 'gx-goods__page--on': n === replaceLogPage.page }" @click="getReplaceLogPage(n)">{{ n }}</button>
              <button class="gx-goods__page" :disabled="replaceLogPage.page >= replaceLogTotalPages" @click="getReplaceLogPage(replaceLogPage.page + 1)">下一页</button>
            </div>
          </div> -->
          <div style="padding: 10px 14px;background: rgb(245, 240, 232);" v-if="replaceLogPage.total > 1">
            <Pagination :total="replaceLogPage.total" :page.sync="replaceLogPage.page" :limit.sync="replaceLogPage.page_size" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getReplaceLogPage(replaceLogPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
          </div>
        </div>
      </div>
    </div>

    <!--弹窗：查看标记货源-->
    <div v-if="productMarkViewShow" class="gx-goods__modal" @click.self="productMarkViewShow = false">
      <div class="gx-goods__modal-box gx-goods__modal-box--xl">
        <div class="gx-goods__modal-head">
          <span class="gx-goods__modal-title">查看标记货源</span>
          <button class="gx-goods__modal-close" @click="productMarkViewShow = false">✕</button>
        </div>
        <div class="gx-goods__modal-body">
          <div class="gx-goods__table gx-goods__table--plain">
            <table>
              <thead>
              <tr>
                <th>图片</th>
                <th>标题</th>
                <th>商品ID</th>
                <th>价格</th>
                <th>商家名称</th>
                <th>标记时间</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(r, i) in productMarkViewItems" :key="i">
                <td class="gx-cloud__mono">
                  <el-popover
                      placement="top"
                      :fallback-placements="[ 'top', 'right', 'left','bottom']"
                      width="350"
                      trigger="hover" :disabled="!r.image">
                    <div class="popover-content">
                      <el-image :src="r.image" fit="contain" style="width:100%;height: auto"></el-image>
                    </div>
                    <div slot="reference">
                      <el-image v-if="r.image" :src="r.image" fit="cover" style="width:60px;height:60px" :preview-src-list="[r.image]"></el-image><span v-else>-</span>
                    </div>
                  </el-popover>
                </td>
                <td class="gx-goods__mono">{{ r.title || '--' }}</td>
                <td class="gx-goods__mono">{{ r.offer_id || '--' }}</td>
                <td class="gx-goods__mono">{{ r.price || '--' }}</td>
                <td class="gx-goods__mono">{{ r.shop_name || '--' }}</td>
                <td class="gx-goods__mono">{{ r.mark_at_text || '--' }}</td>
                <td>
                  <a :href="`https://detail.1688.com/offer/${r.offer_id}.html`" target="_blank" rel="noopener noreferrer" class="gx-cloud__link" v-if="r.offer_id">查看商品</a>
                  <span v-else>-</span>
                </td>
              </tr>
              <tr v-if="!productMarkViewItems.length">
                <td :colspan="7" class="gx-goods__empty">暂无标记</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div style="padding: 10px 14px;background: rgb(245, 240, 232);" v-if="replaceLogPage.total > 1">
            <Pagination :total="replaceLogPage.total" :page.sync="replaceLogPage.page" :limit.sync="replaceLogPage.page_size" :page-sizes="[10, 20, 50, 100,  200, 300, 400]" @pagination="getReplaceLogPage(replaceLogPage.page)"  layout="total, sizes, prev, pager, next, jumper" />
          </div>
        </div>
      </div>
    </div>


    <!-- 商品编辑器（复用原版组件，抖店/微信共用） -->
    <doudian-product-editor-dialog
      :visible.sync="editorVisible"
      :product-id.sync="currentEditProductId"
      :search-params="searchData"
      :goods-status="state"
      :tab-status="isDoudian ? activeDoudianTabConfig.tabStatus : ''"
      :shop-type="shopType"
      :sidebar-mode="editorSidebarMode"
      :initial-sidebar-page="pageData.page"
      :initial-sidebar-page-size="pageData.page_size"
      :sidebar-items="editorSidebarItems"
      @saved="handleEditorSaved"
    />

    <!-- Bixi 组件容器（低效/清理商品） -->
    <div id="huhu"></div>
    <div id="huhu_clean"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import PageSizeSelect from '../../components/newUi/PageSizeSelect.vue'
import gxLoading from '../../mixins/gxLoading'
import { Bixi } from '@open-fxg/bixi-vue'
import DoudianProductEditorDialog from '../uc_goods/components/DoudianProductEditorDialog.vue'
import Pagination from '../../components/newUi/Pagination.vue'

const MY_GOODS_PAGE_SIZES = [10, 20, 50, 100, 200, 500, 1000]

export default {
  name: 'NewMyGoodsPage',
  components: { Bixi, DoudianProductEditorDialog, GxLoading, PageSizeSelect, Pagination },
  mixins: [gxLoading],
  props: {
    initialShopType: { type: Number, default: 1 },
    title: { type: String, default: '我的商品' }
  },
  data() {
    return {
      shopType: 1,
      state: 0,
      activeDoudianTab: 'all',
      searchData: { shop_id: '', product_title: '', platform_product_id: '', cloud_source_product_id: '', shop_groupids: [], created_at: null, sales_min: null, sales_max: null, sales_sort: null },
      shopList: [],
      groupList: [],
      list: [],
      checkList: [],
      pageData: { page_size: 20, page: 1, total: 0 },
      pageSizeOptions: MY_GOODS_PAGE_SIZES,
      statusTabs: [
        { label: '全部商品', val: 0, countKey: 'total', color:'#1a1a2e'},
        { label: '售卖中', val: 3, countKey: 'selling', color:'#52c41a' },
        { label: '仓库中', val: 4, countKey: 'warehouse', color: '#1677ff' },
        { label: '草稿箱', val: 6, countKey: 'draft', color:'#fb923c' },
        { label: '审核不通过', val: 5, countKey: 'review_rejected', color:'#c8443c' },
        { label: '待铺货', val: 1, countKey: 'pending', color:'#666666' },
        { label: '铺货失败', val: 2, countKey: 'distribute_failed', color:'#c8443c' }
      ],
      doudianStatusTabs: [
        { key: 'all', label: '全部商品', countKey: 'total', color: '#1a1a2e' },
        { key: 'selling', label: '已上架', tabStatus: 'selling', countKey: 'selling', color: '#52c41a' },
        { key: 'warehouse', label: '仓库中', tabStatus: 'warehouse', countKey: 'warehouse', color: '#1677ff' },
        { key: 'draft', label: '草稿箱', tabStatus: 'draft', countKey: 'draft', color: '#fb923c' },
        { key: 'banned', label: '已封禁', tabStatus: 'banned', countKey: 'banned', color: '#c8443c' },
        { key: 'reviewing', label: '审核中', tabStatus: 'reviewing', countKey: 'reviewing', color: '#1677ff' },
        { key: 'review_rejected', label: '审核不通过', tabStatus: 'review_rejected', countKey: 'review_rejected', color: '#c8443c' },
        { key: 'off_shelf_reminder', label: '下架提醒', countKey: null, color: '#c8443c' },
        { key: 'pending', label: '待铺货', tabStatus: 'pending', countKey: 'pending', color: '#666666' },
        { key: 'distribute_failed', label: '铺货失败', tabStatus: 'distribute_failed', countKey: 'distribute_failed', color: '#c8443c' },
      ],
      statusStatistics: {
        total: 0,
        selling: 0,
        warehouse: 0,
        draft: 0,
        banned: 0,
        reviewing: 0,
        review_rejected: 0,
        pending: 0,
        distribute_failed: 0,
        legacy_status_counts: {
          total: 0,
          selling: 0,
          warehouse: 0,
          draft: 0,
          review_rejected: 0,
          pending: 0,
          distribute_failed: 0,
        },
      },
      openLoading: false,
      syncSubmitting: false,
      componentConfig: { componentId: 524 },
      // SKU替换记录
      replaceLogShow: false,
      replaceLogList: [],
      replaceLogPage: { limit: 10, page: 1, total: 0 },
      currentReplaceLogProductId: null,
      // 编辑器
      editorVisible: false,
      currentEditProductId: '',
      editorSidebarMode: 'provided',
      editorSidebarItems: [],

      productMarkViewShow: false,
      productMarkViewLoading: false,
      productMarkViewItems: [],
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.page_size))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    replaceLogTotalPages() {
      return Math.max(1, Math.ceil(this.replaceLogPage.total / this.replaceLogPage.limit))
    },
    replaceLogPages() {
      const total = this.replaceLogTotalPages
      const nums = []
      const start = Math.max(1, Math.min(this.replaceLogPage.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    allChecked() {
      return this.list.length > 0 && this.checkList.length === this.list.length
    },
    isDoudian() {
      return this.shopType === 1
    },
    currentStatusTabs() {
      return this.isDoudian ? this.doudianStatusTabs : this.statusTabs
    },
    activeDoudianTabConfig() {
      return this.doudianStatusTabs.find(tab => tab.key === this.activeDoudianTab) || this.doudianStatusTabs[0]
    },
    isHost() {
      return [true, 1, '1', 'true'].includes(this.$store.state.login.is_host)
    }
  },
  created() {
    this.shopType = this.initialShopType || 1
    this.loadShops()
    this.loadGroups()
    const query = this.$route.query
    if (query.cloud_source_product_id) {
      this.searchData.cloud_source_product_id = String(query.cloud_source_product_id)
    }
    if (query.shop_id) {
      this.searchData.shop_id = query.shop_id ? String(query.shop_id) : ''
    }
    this.getList(true)
  },
  methods: {
    ...mapActions({
      getGoodsList: 'ucenter/getGoodsList',
      getGoodsStatusStatistics: 'ucenter/getGoodsStatusStatistics',
      getDdShopList: 'ucenter/getDdShopList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      productsOperationUp: 'ucenter/productsOperationUp',
      getGoodsCloudSource: 'ucenter/getGoodsCloudSource',
      opSyncProduct: 'ucenter/opSyncDistributeDoudianProducts',
      getReplaceLogList: 'ucenter/getReplaceLogList',
      fetchSingleShopInfo: 'index/fetchSingleShopInfo',
      getProductMarkable: "ucenter/getProductMarkable",
    }),
    loadShops() {
      this.getDdShopList({
        data: { shop_type: this.shopType },
        success: (res) => {
          if (res.code === 200) {
            const d = res.data
            this.shopList = d.list && d.list.list ? d.list.list : (Array.isArray(d.list) ? d.list : [])
          }
        }
      })
    },
    loadGroups() {
      this.getShopBoardGroupList({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    onShopChange() {
      this.doSearch()
    },
    switchState(tab) {
      if (this.isDoudian) {
        this.activeDoudianTab = tab.key
      } else {
        this.state = tab.val
      }
      this.checkList = []
      this.pageData.page = 1
      this.getList(true)
    },
    isStatusTabActive(tab) {
      return this.isDoudian ? this.activeDoudianTab === tab.key : this.state === tab.val
    },
    getStatusCount(tab) {
      if (!tab.countKey) return '--'
      const statistics = this.isDoudian
        ? this.statusStatistics
        : this.statusStatistics.legacy_status_counts || {}
      return statistics[tab.countKey] || 0
    },
    doSearch() {
      this.pageData.page = 1
      this.getList(true)
    },
    resetSearch() {
      this.searchData = { shop_id: '', product_title: '', platform_product_id: '', cloud_source_product_id: '', shop_groupids: [], created_at: null, sales_min: null, sales_max: null, sales_sort: null }
      if (this.isDoudian) {
        this.activeDoudianTab = 'all'
      } else {
        this.state = 0
      }
      this.checkList = []
      this.pageData.page = 1
      this.getList(true)
    },
    clearCheck() {
      this.checkList = []
    },
    showFeatureInProgress() {
      this.$message.info('功能完善中')
    },
    bindSort() {
      const sort = this.searchData.sales_sort
      this.searchData.sales_sort = sort === 1 ? 2 : sort === 2 ? null : 1
      this.pageData.page = 1
      this.getList(true)
    },
    onPageSizeChange(size) {
      this.pageData.page_size = size
      this.pageData.page = 1
      this.getList(true, 1)
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      if (this.isDoudian && this.activeDoudianTab === 'off_shelf_reminder') {
        this.list = []
        this.pageData.total = 0
        this.checkList = []
        return
      }
      const param = {
        page_size: this.pageData.page_size,
        page: this.pageData.page,
        shop_type: this.shopType
      }
      Object.assign(param, this.searchData)
      if (!Array.isArray(param.shop_groupids) || param.shop_groupids.length === 0) delete param.shop_groupids
      if (!Array.isArray(param.created_at) || param.created_at.length !== 2) delete param.created_at
      if (!Number.isInteger(param.sales_min) || param.sales_min < 0) delete param.sales_min
      if (!Number.isInteger(param.sales_max) || param.sales_max < 0) delete param.sales_max
      if (param.sales_sort !== 1 && param.sales_sort !== 2) delete param.sales_sort
      if (this.isDoudian) {
        delete param.status
        if (this.activeDoudianTabConfig.tabStatus) {
          param.tab_status = this.activeDoudianTabConfig.tabStatus
        } else {
          delete param.tab_status
        }
      } else {
        param.status = this.state
      }
      const statisticsParam = Object.assign({}, param)
      delete statisticsParam.status
      delete statisticsParam.primary_status
      delete statisticsParam.tab_status
      delete statisticsParam.platform_ban_status
      delete statisticsParam.platform_stock_status
      this.getGoodsStatusStatistics({
        data: statisticsParam,
        success: (res) => {
          if (res.code === 200) {
            this.statusStatistics = Object.assign({}, this.statusStatistics, res.data)
          } else {
            this.$message({ message: res.msg || '获取商品状态统计失败', type: 'error' })
          }
        }
      })
      this.loadingStart()
      this.getGoodsList({
        data: param,
        success: (res) => {
          this.loadingEnd()
          if (res.code === 200) {
            this.list = res.data.list
            this.pageData.total = res.data.pagination ? res.data.pagination.total : (res.data.total || 0)
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }
      })
    },
    toggleOne(id) {
      const idx = this.checkList.indexOf(id)
      if (idx > -1) this.checkList.splice(idx, 1)
      else this.checkList.push(id)
    },
    toggleAll() {
      if (this.allChecked) this.checkList = []
      else this.checkList = this.list.map((i) => i.id)
    },
    batchOp(type) {
      if (!this.checkList.length) {
        this.$message.warning('请勾选商品')
        return
      }
      this.confirmOp(this.checkList, type)
    },
    singleOp(item, type) {
      this.confirmOp([item.id], type)
    },
    confirmOp(ids, type) {
      const label = type === 1 ? '上架' : type === 2 ? '下架' : '删除'
      this.$confirm(`确定${label}选中的商品吗？${type === 3 ? '此操作不可恢复！' : ''}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.productsOperationUp({
          data: { product_ids: ids, type, shop_type: this.shopType },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success(res.msg || res.message)
              this.checkList = []
              this.getList(true)
            } else {
              this.$message.error(res.msg || res.message)
            }
          }
        })
      }).catch(() => {})
    },
    /* ── 一键同步（抖店） ── */
    postSyncProduct() {
      this.$confirm('确认同步商家全部抖店商品吗？会跳过店铺商品应用异常的商品！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.syncSubmitting = true
        this.opSyncProduct({
          data: {},
          success: (res) => {
            this.syncSubmitting = false
            if (res.code === 200) {
              this.$message.success(res.msg || res.message)
              this.getList(false)
            } else {
              this.$message.error(res.msg || res.message)
            }
          }
        })
      }).catch(() => {
        this.syncSubmitting = false
      })
    },
    /* ── 查看云商品 ── */
    handleViewCloudProduct(item) {
      this.getGoodsCloudSource({
        id: item.id,
        success: (res) => {
          if (res.code === 200 && res.data && res.data.source_product_id) {
            const route = this.$router.resolve({
              path: '/new_cloud_workbench',
              query: { menu: 'cloud', source_product_id: res.data.source_product_id,tab:res.data.cloud_source_type==='shared'?2:1 }
            })
            window.open(route.href, '_blank')
          } else {
            this.$message({ message: res.msg || '未找到对应云商品', type: 'error' })
          }
        }
      })
    },
    /* ── SKU替换记录 ── */
    handleViewReplaceLogs(item) {
      this.currentReplaceLogProductId = item.product_id
      this.replaceLogPage.page = 1
      this.replaceLogPage.total = 0
      this.replaceLogList = []
      this.replaceLogShow = true
      this.getReplaceLogPage(1)
    },
    getReplaceLogPage(page) {
      if (!this.currentReplaceLogProductId) return
      this.replaceLogPage.page = page
      this.getReplaceLogList({
        data: {
          product_id: this.currentReplaceLogProductId,
          page: this.replaceLogPage.page,
          page_size: this.replaceLogPage.limit
        },
        success: (res) => {
          this.replaceLogLoading = false
          if (res.code === 200) {
            this.replaceLogList = res.data.list || []
            this.replaceLogPage.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    /* ── 商品编辑（复用原版编辑器，抖店/微信共用） ── */
    openEditor(item) {
      this.editorSidebarMode = 'provided'
      this.editorSidebarItems = item ? [item] : []
      this.currentEditProductId = item.id
      this.editorVisible = true
    },
    openFilteredEditor() {
      const currentPageItems = Array.isArray(this.list) ? this.list : []
      if (!currentPageItems.length) {
        this.$message({ message: '当前筛选条件下暂无商品', type: 'warning' })
        return
      }
      const editableItem = currentPageItems.find(item => Number(item.platform_product_id) > 0)
      if (!editableItem) {
        this.$message({ message: '当前筛选商品中没有可编辑的商品', type: 'warning' })
        return
      }
      this.editorSidebarMode = 'provided'
      this.editorSidebarItems = currentPageItems
      this.currentEditProductId = editableItem.id
      this.editorVisible = true
    },
    handleEditorSaved(data, keepOpen) {
      if (!keepOpen) {
        this.editorVisible = false
      }
      this.pageData.page = 1
      this.checkList = []
      this.getList(false)
    },
    /* ── 低效/清理商品（Bixi） ── */
    getToken() {
      return new Promise((resolve) => {
        const ecopenConfig = localStorage.getItem('ecopenConfig') ? JSON.parse(localStorage.getItem('ecopenConfig')) : {}
        const now = new Date().getTime()
        if (!ecopenConfig.token || ecopenConfig.token.expire_time * 1000 < now) {
          this.fetchSingleShopInfo({
            success: (res) => {
              localStorage.setItem('ecopenConfig', JSON.stringify(res.data))
              resolve(res.data)
            }
          })
        } else {
          resolve(ecopenConfig)
        }
      })
    },
    openBixi() {
      this.openLoading = true
      this.getToken().then(data => {
        this.openLoading = false
        window.ecopen.start({
          token: data.token.token,
          appId: data.appId,
          shopId: data.shopId,
          blockedDistributeComponents: [509]
        })
        window.ecopen.bixi(document.getElementById('huhu'), {
          componentId: 509,
          extra: {}
        })
      })
    },
    openCleanBixi() {
      this.openLoading = true
      this.getToken().then(data => {
        this.openLoading = false
        window.ecopen.start({
          token: data.token.token,
          appId: data.appId,
          shopId: data.shopId,
          blockedDistributeComponents: [524]
        })
        window.ecopen.bixi(document.getElementById('huhu_clean'), {
          componentId: 524,
          extra: {}
        })
      })
    },
    statusStyle(item) {
      if (this.isDoudian) {
        const map = {
          selling: ['rgb(82, 196, 26)', 'rgb(246, 255, 237)', 'rgb(183, 235, 143)'],
          warehouse: ['rgb(22, 119, 255)', 'rgb(230, 244, 255)', 'rgb(145, 202, 255)'],
          draft: ['rgb(251, 146, 60)', 'rgb(255, 247, 230)', 'rgb(255, 213, 145)'],
          reviewing: ['rgb(22, 119, 255)', 'rgb(230, 244, 255)', 'rgb(145, 202, 255)'],
          review_rejected: ['rgb(200, 68, 60)', 'rgb(255, 245, 245)', 'rgb(255, 205, 210)'],
          pending: ['rgb(102, 102, 102)', 'rgb(245, 245, 245)', 'rgb(217, 217, 217)'],
          distribute_failed: ['rgb(200, 68, 60)', 'rgb(255, 245, 245)', 'rgb(255, 205, 210)'],
        }
        const [color, bg, border] = map[item.primary_status] || map.draft
        return { color, background: bg, border: `1px solid ${border}` }
      }
      const s = item.platform_status
      // const map = {
      //   3: ['#4ADE80', 'rgba(74,222,128,.1)', 'rgba(74,222,128,.3)'],
      //   4: ['#3FB6E0', 'rgba(63,182,224,.1)', 'rgba(63,182,224,.3)'],
      //   6: ['#4A4A6A', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.3)'],
      //   5: ['#F87171', 'rgba(248,113,113,.1)', 'rgba(248,113,113,.3)'],
      //   1: ['#FB923C', 'rgba(251,146,60,.1)', 'rgba(251,146,60,.3)'],
      //   2: ['#F87171', 'rgba(248,113,113,.1)', 'rgba(248,113,113,.3)']
      // }
      const map = {
        3: ['rgb(22, 119, 255)', 'rgb(230, 244, 255)', 'rgb(145, 202, 255)'],
        4: ['rgb(82, 196, 26)', 'rgb(246, 255, 237)', 'rgb(183, 235, 143)'],
        6: ['rgb(251, 146, 60)', 'rgba(139,157,195,.1)', 'rgba(139,157,195,.3)'],
        5: ['#F87171', 'rgba(248,113,113,.1)', 'rgba(248,113,113,.3)'],
        1: ['rgb(22, 119, 255)', 'rgb(230, 244, 255)', 'rgb(145, 202, 255)'],
        2: ['#F87171', 'rgba(248,113,113,.1)', 'rgba(248,113,113,.3)']
      }

      // 常量定义
      const COLOR_FAILED = ['rgb(200, 68, 60)', 'rgb(255, 245, 245)', 'rgb(255, 205, 210)'];
      const COLOR_DEFAULT = ['rgb(251, 146, 60)', 'rgb(255, 247, 230)', 'rgb(255, 213, 145)'];

      // 使用
      const [color, bg, border] = map[s] || (item.status_text === "铺货失败" ? COLOR_FAILED : COLOR_DEFAULT);

      return { color, background: bg, border: `1px solid ${border}` }
    },
    getProductStatusText(item) {
      return this.isDoudian ? (item.primary_status_text || item.status_text || item.status) : (item.status_text || item.status)
    },
    getProductStatusBadges(item) {
      return this.isDoudian && Array.isArray(item.status_badges) ? item.status_badges : []
    },
    canEditProduct(item) {
      if (this.isDoudian) {
        return !['off_shelf_reminder', 'distribute_failed'].includes(this.activeDoudianTab) && Number(item.platform_product_id) > 0
      }
      return this.state !== 2 && Number(item.platform_product_id) > 0 && this.shopType !== 7
    },
    canOperateProduct(item) {
      if (this.isDoudian) {
        const policy = item.operation_policy || {}
        return Boolean(policy.can_launch || policy.can_offline)
      }
      return [3, 4, 5].includes(item.platform_status)
    },
    getProductOperationType(item) {
      if (this.isDoudian) {
        return item.operation_policy && item.operation_policy.can_offline ? 2 : 1
      }
      return item.platform_status == 4 ? 2 : 1
    },
    getProductOperationText(item) {
      return this.getProductOperationType(item) === 2 ? '下架' : '上架'
    },

    /**
     *  ── 标记货源查看 ── */
    handleViewProductMarks(item) {
      this.productMarkViewShow = true
      this.productMarkViewLoading = true
      this.productMarkViewItems = []
      this.getProductMarkable({
        data: { product_id: item.product_id, shop_id: item.shop_id },
        success: (res) => {
          this.productMarkViewLoading = false
          if (res.code === 200) {
            this.productMarkViewItems = Array.isArray(res.data) ? res.data : []
          } else {
            this.$message.error(res.message || res.msg || '获取标记货源失败')
          }
        }
      })
    },

  }
}
</script>

<style scoped>
.gx-goods__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 24px;
  font-weight: 600;
  color: #1A1A2E;
 /* margin: 0 0 20px;*/
}
.gx-goods__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 11px 14px;
  margin-bottom: 12px;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 8px;
}
.gx-goods__form{
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgb(224, 224, 236);
}
.gx-goods__filter-input-num{
  width: 70px;
  text-align: center;
}
.gx-goods__filter-input-num :deep(.el-input__inner) {
  padding-left: 6px;
  padding-right: 6px;
}
.gx-goods__select {
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  background: #FFFFFF;
  font-size: 12px;
  color: #303133;
  outline: none;
  min-width: 130px;
  transition: border-color .15s ease;
}
.gx-goods__select:focus {
  border-color: #C8443C;
}
.gx-goods__input {
  width: 140px;
  height: 32px;
  padding: 0 11px;
  border-radius: 6px;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  color: #303133;
  outline: none;
  box-sizing: border-box;
  transition: border-color .15s ease;
}
.gx-goods__input:focus {
  border-color: #C8443C;
}
.gx-goods__spacer {
  flex: 1;
}
.gx-goods__btn {
  height: 26px;
  padding: 0px 10px;
  border-radius: 6px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  font-size: 11px;
  color: #666;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: all .15s ease;
  font-weight: 400;
}
.gx-goods__btn:hover:not(:disabled) {
  color: var(--gx-black);
  background:rgb(245,245,245);
}
.gx-goods__btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-goods__btn--primary {
  background: linear-gradient(135deg, #E85D4E, #F47B5A);
  border: 1px solid transparent;
  font-weight: 600;
  color: #FFFFFF;
  box-shadow: 0 2px 4px rgba(232, 93, 78, .25);
}
.gx-goods__btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #D44A3C, #E8694A);
  color: #FFFFFF;
  box-shadow: 0 3px 8px rgba(232, 93, 78, .35);
}
.gx-goods__btn--danger {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
  font-weight: 500;
}
.gx-goods__btn--danger:hover:not(:disabled) {
  background: #FFE5E3;
  border-color: #F5B5B0;
  color: #C8443C;
}
/* 列表面板卡片 */
.gx-goods__card {
  border-radius: 10px;
  border: 1px solid #EBEEF5;
  background: #FFFFFF;
  overflow: visible;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
  position: relative;
}
.gx-goods__status-tabs {
  display: flex;
  margin-bottom: 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  background: #FFFFFF;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #e0e0ec;
  position: relative;
  z-index: 2;
}
.gx-goods__status-tab {
  padding: 9px 14px;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  line-height: 1.3;
  background: rgb(245, 240, 232);
  color: rgb(102, 102, 102);
  font-weight: 400;
  transition: 0.15s;
  white-space: nowrap;
}
.gx-goods__status-tab~.gx-goods__status-tab{
  border-left: 1px solid #e0e0ec;
}
.gx-goods__status-tab--on {
  font-weight: 600;
  background: #ffffff;
}
.gx-goods__status-count {
  margin-left: 4px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
}

.gx-goods__batch {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #FAF6EE;
  border-bottom: 1px solid #EFE6D2;
  border-radius: 0;
  margin-bottom: 0;
  flex-wrap: wrap;
}
.gx-goods__batch-label {
  font-size: 12px;
  color: #606266;
  margin-right: 4px;
  font-weight: 500;
  line-height: 1;
}
.gx-goods__batch .gx-goods__btn {
  box-shadow: none;
}
.gx-goods__table {
  border-radius: 0;
  overflow: visible;
  border: none;
  margin-bottom: 0;
  background: #FFFFFF;
}
/* 弹窗内的独立表格：保留描边与圆角 */
.gx-goods__table--plain {
  border: 1px solid #EBEEF5;
  border-radius: 10px 10px 0 0
  ;
  overflow: hidden;
}
.gx-goods__table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-goods__table th {
  padding: 11px 14px;
  text-align: left;
  background: #FAF6EE;
  font-size: 12px;
  font-weight: 500;
  color: #4A4A6A;
  white-space: nowrap;
  border-bottom: 1px solid #EFE6D2;
}
.gx-goods__table td {
  padding: 12px 14px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid #EBEEF5;
}
.gx-goods__sortable {
  cursor: pointer;
  user-select: none;
}
.gx-goods__sort-arrow {
  font-size: 9px;
  color: #A0AEC0;
  display: inline-block;
}
.gx-goods__sort-arrow--on {
  color: #C8443C;
}
.gx-goods__checkbox {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid #D0D0DD;
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .15s ease;
}
.gx-goods__checkbox:hover {
  border-color: #C8443C;
}
.gx-goods__checkbox--on {
  background: #C8443C;
  border-color: #C8443C;
  box-shadow: 0 1px 3px rgba(200, 68, 60, 0.18);
}
.gx-goods__info {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  min-width: 240px;
}
.gx-goods__img {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(135deg, #F2F3F7, #FFFFFF);
  border: 1px solid #EBEEF5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-goods__img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-goods__title {
  font-size: 13px;
  color: #1A1A2E;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-goods__meta {
  font-size: 10px;
  color: rgb(153, 153, 153);
  margin-bottom: 4px;
  margin-top: 4px;
}
.gx-goods__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-goods__gold {
  color: rgb(200, 68, 60)!important;
  font-weight: 600;
}
.gx-goods__dim {
  color: rgb(153, 153, 153)!important;
}
.gx-goods__status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  display: inline-block;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-goods__status-error {
  max-width: 280px;
  line-height: 1.5;
  white-space: normal;
}
.gx-goods__status-badge {
  margin-left: 4px;
  color: rgb(251, 146, 60);
  background: rgb(255, 247, 230);
  border: 1px solid rgb(255, 213, 145);
}
.gx-goods__status-badge--danger {
  color: rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  border-color: rgb(255, 205, 210);
}
.gx-goods__ops {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  width: 350px;
}
.gx-goods__ops~.gx-goods__ops{
  margin-top: 5px;
}
.gx-goods__op {
  height: 24px;
  padding: 0 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  color: #606266;
  white-space: nowrap;
  transition: all .15s;
}
.gx-goods__op:hover {
  color: var(--gx-black);
  background: rgb(245,245,245);
}
.gx-goods__op--primary {
  background: #E6F4FF;
  border-color: #91CAFF;
  color: var(--gx-cyan);
}
.gx-goods__op--primary:hover {
  background: var(--gx-cyan);
  border-color: var(--gx-cyan);
  color: #ffffff;
}
.gx-goods__op--danger {
  background: #FFF1F0;
  border-color: #FFCCC7;
  color: #C8443C;
}
.gx-goods__op--warning {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(255, 213, 145);
  color: rgb(251, 146, 60);
}
.gx-goods__op--warning:hover {
  background: rgb(255, 247,230);
}
.gx-goods__op--red,
.gx-goods__op--red:hover,
.gx-goods__op--danger:hover{
  background: var(--gx-red);
  border-color: var(--gx-red);
  color: #ffffff;
}
.gx-goods__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}
.gx-goods__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #EBEEF5;
  background: #FAF6EE;
  border-radius: 0 0 10px 10px;
}
.gx-goods__pager-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-goods__pager-total {
  font-size: 12px;
  color: #606266;
}
.gx-goods__pager-btns {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.gx-goods__page {
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #E4E7ED;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #606266;
  transition: all .15s ease;
}
.gx-goods__page:hover:not(:disabled) {
  border-color: #C8443C;
  color: #C8443C;
}
.gx-goods__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-goods__page--on {
  background: #C8443C;
  border-color: #C8443C;
  color: #FFFFFF;
  font-weight: 700;
  box-shadow: 0 1px 4px rgba(200, 68, 60, 0.18);
}
.gx-goods__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-goods__modal-box {
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}
.gx-goods__modal-box--lg {
  max-width: 640px;
}
.gx-goods__modal-box--xl {
  max-width: 1100px;
}
.gx-goods__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  flex-shrink: 0;
  background: #FFFFFF;
}
.gx-goods__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-goods__modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  font-size: 14px;
}
.gx-goods__modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}
.gx-goods__tip {
  font-size: 12px;
  color: #6A6A8A;
  margin-bottom: 10px;
}
.gx-goods__link {
  color: #3FB6E0;
  text-decoration: none;
  word-break: break-all;
}
</style>
